<template>
  <aside class="lav-cards__card-wrapper" data-slider-item>
    <div
      class="lav-card__container lav-card__container--border lav-card__container--slim"
    >
      <div class="partner-card__content">
        <div class="partner-card__top">
          <div class="partner-card__top-left">
            <h2 class="partner-card__name">
              <a v-if="partner.url" :href="partner.url" v-html="partner.name" />
              <span v-else v-html="partner.name" />
            </h2>
            <p class="partner-card__title">
              {{ partner.title }}
            </p>
            <a v-if="partner.url && partner.companyLogo" :href="partner.url">
              <img class="partner-card__logo" :src="partner.companyLogo" />
            </a>
            <img
              v-else-if="partner.companyLogo"
              class="partner-card__logo"
              :src="partner.companyLogo"
            />
          </div>
          <div class="partner-card__top-right">
            <a v-if="partner.url && partner.image" :href="partner.url">
              <img
                class="partner-card__image"
                :src="partner.image"
                :alt="partner.title"
              />
            </a>
            <img
              v-else-if="partner.image"
              class="partner-card__image"
              :src="partner.image"
              :alt="partner.title"
            />
          </div>
        </div>
        <div class="partner-card__bottom">
          <p v-if="partner.description" class="partner-card__description">
            {{ partner.description }}
          </p>
        </div>
      </div>
      <svg
        v-if="partner.icon"
        :class="`slim-slider-partner-svg ${partner.icon}`"
      >
        <use :href="`#${partner.icon}`" />
      </svg>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'PartnerCard',

  props: {
    partner: {
      type: Object,
      required: true,
    },
  },
};
</script>
